const UttarakhandData =[
    {
        City: "Roorkee",
        nameOfResource: "oxygenCylinder",
        Address: "Roorkee,Uttarakhand",
        Contact: "9837060376",
        Price: " ",
        Comments: " ",
        verficationDataTime: "4th May",
        vendorName: "oxygen refill",
    },
    {
        
        City: "",
        nameOfResource: "Ambulance",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Beds",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "bloodBanks",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "foodDistribution",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "homeCare",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Medicines",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "resourceAgencies",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "womenInCardiology",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "humanSupporters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "Lakkhi Bagh, Dehradun",
        Contact: "8273156206, 01352728970",
        Price: " ",
        Comments: "Refill available, Please do not pay any money for prebooking of cylinders",
        verficationDataTime: "",
        vendorName: "Bharat oxygen",
    },
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "Ghanta Ghar, Dehra Dun",
        Contact: "7500737373",
        Price: " ",
        Comments: "Wrong number, Any help please contact 9520329258",
        verficationDataTime: "",
        vendorName: "Rama surgical house",
    },
   
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "Kanvali road, Dehradun",
        Contact: "8979812049",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "Shri Ambika Gases",
    },
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "Saharanpur Road, Dehradun ",
        Contact: "1352620853",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "Gupta Gases",
    },
   
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "",
        Contact: "Call -  6395666838, Whatsapp - 6397463144",
        Price: " ",
        Comments: "Oxygen concentrators, Please do not pay any money for prebooking of cylinders",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "oxygenRefill",
        Address: "Dehradun",
        Contact: ".01352728970 , 9953696969",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "Bharat Oxygen, Lakhi Road",
    },
    {
    
        City: "",
        nameOfResource: "oxygenRefill",
        Address: "Dehradun",
        Contact: "9897530007",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "Balaji Gases",
    },

    {
    
        City: "",
        nameOfResource: "plasmaDonors",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "testingCenters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
 
];


export default UttarakhandData